(() => {
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  if (document.body.classList.contains('template-404')) {
    document.querySelectorAll('link[rel="canonical"]').forEach((link) => link.remove());
  }

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const routeTransition = document.querySelector('[data-route-transition]');
  let showRouteTransition = false;
  try {
    showRouteTransition = window.sessionStorage.getItem('dcRouteTransition') === '1';
    window.sessionStorage.removeItem('dcRouteTransition');
  } catch {}

  if (routeTransition && showRouteTransition && !reducedMotion) {
    routeTransition.hidden = false;
    routeTransition.classList.add('route-car-change');
    const finish = () => {
      routeTransition.hidden = true;
      routeTransition.classList.remove('route-car-change');
    };
    routeTransition.addEventListener('animationend', (event) => {
      if (event.target === routeTransition) finish();
    }, { once: true });
    window.setTimeout(finish, 1400);
  }

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const target = new URL(link.href, window.location.href);
    if (target.origin !== window.location.origin || target.protocol !== window.location.protocol) return;
    if (target.pathname === window.location.pathname && target.search === window.location.search) return;
    try { window.sessionStorage.setItem('dcRouteTransition', '1'); } catch {}
  });

  document.querySelectorAll('[data-dc-header]').forEach((header) => {
    const toggle = header.querySelector('[data-menu-toggle]');
    const backdrop = header.querySelector('[data-menu-backdrop]');
    const closeButton = header.querySelector('[data-menu-close]');
    const openIcon = header.querySelector('[data-menu-open-icon]');
    const closeIcon = header.querySelector('[data-menu-close-icon]');
    if (!toggle || !backdrop) return;

    let previousOverflow = '';
    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const close = () => {
      backdrop.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      openIcon?.removeAttribute('hidden');
      closeIcon?.setAttribute('hidden', '');
      document.body.style.overflow = previousOverflow;
      toggle.focus();
    };

    const open = () => {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      backdrop.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      openIcon?.setAttribute('hidden', '');
      closeIcon?.removeAttribute('hidden');
      backdrop.querySelector(focusableSelector)?.focus();
    };

    toggle.addEventListener('click', () => toggle.getAttribute('aria-expanded') === 'true' ? close() : open());
    closeButton?.addEventListener('click', close);
    backdrop.addEventListener('mousedown', (event) => { if (event.target === backdrop) close(); });
    backdrop.querySelectorAll('a[href]').forEach((link) => link.addEventListener('click', close));
    header.addEventListener('keydown', (event) => {
      if (backdrop.hidden) return;
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...backdrop.querySelectorAll(focusableSelector)];
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  });

  const revealItems = [...document.querySelectorAll('[data-reveal]')];
  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-revealed'));
  } else {
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => revealObserver.observe(item));
  }

  document.querySelectorAll('[data-animated-number]').forEach((node) => {
    const target = Number(node.getAttribute('data-animated-number'));
    if (!Number.isFinite(target)) return;
    if (reducedMotion || !('IntersectionObserver' in window)) { node.textContent = target.toLocaleString('bg-BG'); return; }
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      observer.disconnect();
      const started = performance.now();
      const duration = 1400;
      const tick = (now) => {
        const progress = Math.min(1, (now - started) / duration);
        const eased = 1 - Math.pow(1 - progress, 4);
        node.textContent = Math.round(target * eased).toLocaleString('bg-BG');
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.35 });
    observer.observe(node);
  });

  document.querySelectorAll('[data-mobile-cta]').forEach((cta) => {
    const link = cta.querySelector('a');
    const targets = [...document.querySelectorAll('[data-primary-cta], .site-footer')];
    const visibleTargets = new Set();
    const update = () => {
      const visible = window.scrollY > 160 && visibleTargets.size === 0;
      cta.classList.toggle('is-visible', visible);
      cta.setAttribute('aria-hidden', String(!visible));
      if (link) link.tabIndex = visible ? 0 : -1;
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.isIntersecting ? visibleTargets.add(entry.target) : visibleTargets.delete(entry.target));
      update();
    }, { threshold: 0.08 });
    targets.forEach((target) => observer.observe(target));
    window.addEventListener('scroll', update, { passive: true });
    update();
  });

  const bindPrivacyBannerState = () => {
    const banner = document.querySelector('#shopify-pc__banner');
    if (!banner || banner.dataset.dcPrivacyBound === 'true') return false;
    banner.dataset.dcPrivacyBound = 'true';
    const sync = () => {
      const styles = window.getComputedStyle(banner);
      const visible = banner.isConnected && styles.display !== 'none' && styles.visibility !== 'hidden' && banner.getBoundingClientRect().height > 0;
      document.documentElement.classList.toggle('dc-privacy-open', visible);
    };
    const observer = new MutationObserver(sync);
    observer.observe(banner, { attributes: true, attributeFilter: ['class', 'hidden', 'style', 'aria-hidden'] });
    banner.addEventListener('click', () => window.setTimeout(sync, 0));
    sync();
    return true;
  };
  if (!bindPrivacyBannerState()) {
    let privacyChecks = 0;
    const privacyTimer = window.setInterval(() => {
      privacyChecks += 1;
      if (bindPrivacyBannerState() || privacyChecks >= 30) window.clearInterval(privacyTimer);
    }, 250);
  }

  document.querySelectorAll('[data-cookie-settings]').forEach((button) => {
    button.addEventListener('click', () => {
      if (window.privacyBanner?.showPreferences) {
        window.privacyBanner.showPreferences();
        return;
      }
      if (window.Shopify?.customerPrivacy?.showPreferences) {
        window.Shopify.customerPrivacy.showPreferences();
        return;
      }
      document.querySelector('#shopify-pc__banner__btn-manage-prefs')?.click();
    });
  });

  const initCollections = (root = document) => {
    root.querySelectorAll('[data-collection-catalog]').forEach((catalog) => {
      if (catalog.dataset.collectionInitialized === 'true') return;
      catalog.dataset.collectionInitialized = 'true';

      const grid = catalog.querySelector('[data-collection-grid]');
      const items = [...catalog.querySelectorAll('[data-collection-item]')];
      if (!grid || !items.length) return;

      const search = catalog.querySelector('[data-collection-search]');
      const searchClear = catalog.querySelector('[data-collection-search-clear]');
      const sort = catalog.querySelector('[data-collection-sort]');
      const fuelButtons = [...catalog.querySelectorAll('[data-collection-fuel]')];
      const make = catalog.querySelector('[data-collection-make]');
      const gearbox = catalog.querySelector('[data-collection-gearbox]');
      const year = catalog.querySelector('[data-collection-year]');
      const priceMin = catalog.querySelector('[data-collection-price-min]');
      const priceMax = catalog.querySelector('[data-collection-price-max]');
      const mileageMax = catalog.querySelector('[data-collection-mileage-max]');
      const count = catalog.querySelector('[data-collection-count]');
      const active = catalog.querySelector('[data-collection-active]');
      const empty = catalog.querySelector('[data-collection-empty]');
      let selectedFuel = '';

      const normalize = (value) => String(value || '').trim().toLocaleLowerCase('bg-BG');
      const numericValue = (control) => {
        const value = Number(control?.value);
        return control?.value && Number.isFinite(value) ? value : null;
      };
      const appendOptions = (select, valueKey, labelKey, numeric = false) => {
        if (!select) return;
        const options = new Map();
        items.forEach((item) => {
          const value = item.dataset[valueKey];
          if (value && !options.has(value)) options.set(value, item.dataset[labelKey] || value);
        });
        [...options.entries()]
          .sort((a, b) => numeric ? Number(b[0]) - Number(a[0]) : a[1].localeCompare(b[1], 'bg'))
          .forEach(([value, label]) => select.add(new Option(label, value)));
      };

      appendOptions(make, 'make', 'makeLabel');
      appendOptions(gearbox, 'gearbox', 'gearboxLabel');
      appendOptions(year, 'year', 'year', true);

      const apply = () => {
        const query = normalize(search?.value);
        const selectedMake = normalize(make?.value);
        const selectedGearbox = normalize(gearbox?.value);
        const selectedYear = year?.value || '';
        const minimumPrice = numericValue(priceMin);
        const maximumPrice = numericValue(priceMax);
        const maximumMileage = numericValue(mileageMax);
        const visibleItems = items.filter((item) => {
          const itemPrice = Number(item.dataset.price || 0) / 100;
          const itemMileage = Number(item.dataset.mileage || 0);
          return (!query || normalize(item.dataset.search).includes(query))
            && (!selectedFuel || normalize(item.dataset.fuel) === selectedFuel)
            && (!selectedMake || normalize(item.dataset.make) === selectedMake)
            && (!selectedGearbox || normalize(item.dataset.gearbox) === selectedGearbox)
            && (!selectedYear || item.dataset.year === selectedYear)
            && (minimumPrice === null || itemPrice >= minimumPrice)
            && (maximumPrice === null || itemPrice <= maximumPrice)
            && (maximumMileage === null || itemMileage <= maximumMileage);
        });

        const sortValue = sort?.value || 'featured';
        const number = (item, key) => Number(item.dataset[key] || 0);
        const comparisons = {
          'year-desc': (a, b) => number(b, 'year') - number(a, 'year') || number(a, 'position') - number(b, 'position'),
          'price-asc': (a, b) => number(a, 'price') - number(b, 'price') || number(a, 'position') - number(b, 'position'),
          'price-desc': (a, b) => number(b, 'price') - number(a, 'price') || number(a, 'position') - number(b, 'position'),
          'mileage-asc': (a, b) => number(a, 'mileage') - number(b, 'mileage') || number(a, 'position') - number(b, 'position'),
          featured: (a, b) => number(a, 'position') - number(b, 'position'),
        };
        items.sort(comparisons[sortValue] || comparisons.featured).forEach((item) => grid.append(item));
        const visible = new Set(visibleItems);
        items.forEach((item) => { item.hidden = !visible.has(item); });

        const activeCount = [query, selectedFuel, selectedMake, selectedGearbox, selectedYear, minimumPrice, maximumPrice, maximumMileage]
          .filter((value) => value !== '' && value !== null).length;
        if (count) count.textContent = String(visibleItems.length);
        if (active) {
          active.hidden = activeCount === 0;
          active.textContent = activeCount ? `${activeCount} ${catalog.dataset.activeFiltersLabel || ''}`.trim() : '';
        }
        if (empty) empty.hidden = visibleItems.length !== 0;
        if (searchClear) searchClear.hidden = query.length === 0;
      };

      search?.addEventListener('input', apply);
      searchClear?.addEventListener('click', () => { search.value = ''; search.focus(); apply(); });
      sort?.addEventListener('change', apply);
      [make, gearbox, year, priceMin, priceMax, mileageMax].forEach((control) => {
        control?.addEventListener(control?.matches('input') ? 'input' : 'change', apply);
      });
      fuelButtons.forEach((button) => button.addEventListener('click', () => {
        selectedFuel = normalize(button.dataset.collectionFuel);
        fuelButtons.forEach((option) => {
          const selected = option === button;
          option.classList.toggle('active', selected);
          option.setAttribute('aria-pressed', String(selected));
        });
        apply();
      }));
      catalog.querySelectorAll('[data-collection-reset]').forEach((button) => button.addEventListener('click', () => {
        if (search) search.value = '';
        if (sort) sort.value = 'featured';
        [make, gearbox, year, priceMin, priceMax, mileageMax].forEach((control) => { if (control) control.value = ''; });
        selectedFuel = '';
        fuelButtons.forEach((option) => {
          const selected = normalize(option.dataset.collectionFuel) === '';
          option.classList.toggle('active', selected);
          option.setAttribute('aria-pressed', String(selected));
        });
        apply();
      }));
      apply();
    });
  };

  initCollections();
  document.addEventListener('shopify:section:load', (event) => initCollections(event.target));

  const initServiceCarousels = (root = document) => {
    root.querySelectorAll('[data-service-carousel]').forEach((carousel) => {
      if (carousel.dataset.serviceInitialized === 'true') return;
      carousel.dataset.serviceInitialized = 'true';
      const slides = [...carousel.querySelectorAll('[data-service-slide]')];
      const tabs = [...carousel.querySelectorAll('[data-service-tab]')];
      const current = carousel.querySelector('[data-service-current]');
      const stage = carousel.querySelector('[data-service-stage]');
      const previous = carousel.querySelector('[data-service-prev]');
      const next = carousel.querySelector('[data-service-next]');
      if (!slides.length || !stage) return;

      let active = 0;
      let paused = false;
      let inView = true;
      let dragStart = null;
      let timer = null;
      const autoplay = carousel.dataset.autoplay === 'true' && !reducedMotion;
      const interval = Math.max(3000, Number(carousel.dataset.autoplayMs) || 4000);

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };
      const start = () => {
        stop();
        if (!autoplay || paused || !inView || slides.length < 2) return;
        timer = window.setInterval(() => show(active + 1), interval);
      };
      const show = (index, focusTab = false) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const selected = slideIndex === active;
          slide.hidden = !selected;
          slide.setAttribute('aria-hidden', String(!selected));
          if (selected) slide.querySelector('img')?.setAttribute('loading', 'eager');
        });
        tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === active;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        if (current) current.textContent = String(active + 1);
        if (focusTab) tabs[active]?.focus();
        start();
      };

      previous?.addEventListener('click', () => show(active - 1));
      next?.addEventListener('click', () => show(active + 1));
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => show(index));
        tab.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1, true); }
          else if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1, true); }
          else if (event.key === 'Home') { event.preventDefault(); show(0, true); }
          else if (event.key === 'End') { event.preventDefault(); show(slides.length - 1, true); }
        });
      });
      carousel.addEventListener('pointerenter', () => { paused = true; stop(); });
      carousel.addEventListener('pointerleave', () => { paused = false; start(); });
      carousel.addEventListener('focusin', () => { paused = true; stop(); });
      carousel.addEventListener('focusout', (event) => {
        if (event.relatedTarget instanceof Node && carousel.contains(event.relatedTarget)) return;
        paused = false;
        start();
      });
      stage.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.target.closest('button, a, input, select')) return;
        dragStart = event.clientX;
        stage.setPointerCapture(event.pointerId);
        paused = true;
        stop();
      });
      stage.addEventListener('pointerup', (event) => {
        if (!event.isPrimary || dragStart === null) return;
        const distance = event.clientX - dragStart;
        dragStart = null;
        if (stage.hasPointerCapture(event.pointerId)) stage.releasePointerCapture(event.pointerId);
        if (Math.abs(distance) > 45) show(active + (distance < 0 ? 1 : -1));
        paused = false;
        start();
      });
      stage.addEventListener('pointercancel', () => { dragStart = null; paused = false; start(); });
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          inView = entries.some((entry) => entry.isIntersecting);
          start();
        }, { threshold: 0.35 });
        observer.observe(carousel);
      }
      show(0);
    });
  };

  initServiceCarousels();
  document.addEventListener('shopify:section:load', (event) => initServiceCarousels(event.target));

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const slides = [...gallery.querySelectorAll('.product-image .gallery-slide')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
    const current = gallery.querySelector('[data-gallery-current]');
    const dialog = gallery.querySelector('[data-gallery-dialog]');
    const stage = gallery.querySelector('[data-gallery-lightbox-stage]');
    let active = 0;
    if (!slides.length) return;

    const loadSlide = (index, priority = 'auto') => {
      const slide = slides[(index + slides.length) % slides.length];
      if (slide instanceof HTMLImageElement) {
        slide.loading = 'eager';
        slide.fetchPriority = priority;
      } else if (slide instanceof HTMLVideoElement) {
        slide.preload = priority === 'high' ? 'auto' : 'metadata';
        slide.load();
      } else if (slide instanceof HTMLIFrameElement) {
        slide.loading = 'eager';
      }
    };

    const resetLightboxZoom = () => {
      if (!stage) return;
      stage.dataset.zoomed = 'false';
      const image = stage.querySelector(':scope > img');
      if (image) image.style.transformOrigin = 'center';
    };

    const renderLightboxSlide = () => {
      if (!stage) return;
      resetLightboxZoom();
      const clone = slides[active].cloneNode(true);
      clone.classList.add('is-active');
      clone.setAttribute('aria-hidden', 'false');
      stage.dataset.zoomable = String(clone instanceof HTMLImageElement);
      stage.replaceChildren(clone);
      if (clone instanceof HTMLVideoElement) {
        clone.controls = true;
        clone.preload = 'auto';
        clone.load();
      }
    };

    const openLightbox = () => {
      if (!dialog || !stage) return;
      renderLightboxSlide();
      dialog.showModal();
      gallery.querySelector('[data-gallery-close]')?.focus();
    };

    const show = (index) => {
      active = (index + slides.length) % slides.length;
      loadSlide(active, 'high');
      loadSlide(active - 1);
      loadSlide(active + 1);
      slides.forEach((slide, slideIndex) => {
        const selected = slideIndex === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
        if (!selected && slide instanceof HTMLVideoElement) slide.pause();
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const selected = thumbIndex === active;
        thumb.classList.toggle('active', selected);
        thumb.setAttribute('aria-selected', String(selected));
        if (selected) thumb.querySelector('img')?.setAttribute('loading', 'eager');
      });
      if (current) current.textContent = String(active + 1).padStart(2, '0');
      if (stage && dialog?.open) renderLightboxSlide();
    };
    gallery.querySelectorAll('[data-gallery-prev]').forEach((button) => button.addEventListener('click', () => show(active - 1)));
    gallery.querySelectorAll('[data-gallery-next]').forEach((button) => button.addEventListener('click', () => show(active + 1)));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
    gallery.querySelector('[data-gallery-open]')?.addEventListener('click', openLightbox);
    gallery.querySelector('.product-image-frame')?.addEventListener('click', (event) => {
      if (event.target instanceof HTMLImageElement) openLightbox();
    });
    gallery.querySelector('[data-gallery-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    dialog?.addEventListener('close', resetLightboxZoom);
    stage?.addEventListener('click', (event) => {
      const image = stage.querySelector(':scope > img');
      if (!image || event.target !== image) return;
      if (stage.dataset.zoomed === 'true') {
        resetLightboxZoom();
        return;
      }
      const rect = stage.getBoundingClientRect();
      const x = Math.max(0, Math.min(100, ((event.clientX - rect.left) / rect.width) * 100));
      const y = Math.max(0, Math.min(100, ((event.clientY - rect.top) / rect.height) * 100));
      image.style.transformOrigin = `${x}% ${y}%`;
      stage.dataset.zoomed = 'true';
    });
    dialog?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(active - 1);
      if (event.key === 'ArrowRight') show(active + 1);
    });
    show(0);
  });

  document.querySelectorAll('[data-cv-builder]').forEach((form) => {
    const input = form.querySelector('[data-cv-input]');
    const error = form.querySelector('[data-cv-error]');
    const copy = form.querySelector('[data-cv-copy]');
    const copyText = copy?.querySelector('span');
    const baseUrl = form.getAttribute('data-base-url');
    const vinUrl = form.getAttribute('data-vin-url') || baseUrl;
    if (!input || !baseUrl || !vinUrl) return;
    const cleanIdentifier = () => input.value.trim().replace(/\s+/g, '').toUpperCase();
    const readyLink = () => {
      const identifier = cleanIdentifier();
      if (!identifier) return baseUrl;
      const url = new URL(vinUrl, window.location.origin);
      url.searchParams.set('sub3', identifier);
      return url.toString();
    };
    input.addEventListener('input', () => {
      if (error) error.textContent = '';
      if (copyText) copyText.textContent = form.getAttribute('data-copy-label') || '';
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (cleanIdentifier().length < 3) {
        if (error) error.textContent = form.getAttribute('data-error-message') || '';
        input.focus();
        return;
      }
      window.open(readyLink(), '_blank', 'noopener,noreferrer');
    });
    copy?.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(readyLink());
        if (copyText) copyText.textContent = form.getAttribute('data-copy-success-label') || '';
      } catch {
        if (copyText) copyText.textContent = form.getAttribute('data-copy-blocked-label') || '';
      }
    });
  });

  document.querySelectorAll('[data-review-carousel]').forEach((carousel) => {
    const section = carousel.closest('.google-reviews');
    const previous = section?.querySelector('[data-review-prev]');
    const next = section?.querySelector('[data-review-next]');
    const move = (direction) => {
      const card = carousel.querySelector('.review-card');
      if (!card) return;
      const gap = Number.parseFloat(getComputedStyle(carousel).columnGap || '0');
      carousel.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: reducedMotion ? 'auto' : 'smooth' });
    };
    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
  });
})();
